import { SelfResultItem } from '../Types/SearchTypes'
import { useTranslation } from 'react-i18next'
import UserIcon from './UserIcon'
import Chip from '@mui/material/Chip'
import { useNavigate } from 'react-router-dom'
import WriteOutLink from './WriteOutLink'

interface SearchResultsSelfProps {
  results: SelfResultItem[]
}

const SearchResultsSelf = ({ results }: SearchResultsSelfProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (!results.length) {
    return <div className="no-results">{t('No results found in vocabularies.')}</div>
  }

  const onClickVocabulary = (vocabularyId: number, searchText: string) => () => {
    const searchParam = encodeURIComponent(searchText)
    navigate(`?v=${vocabularyId}&showSearch=false&highlight=${searchParam}`)
  }

  return (
    <ul className="meaning-bundle">
      {results.map((result, itemIndex: number) => (
        <li key={itemIndex}>
          <div className="word">{result.text}</div>
          <ol className={'meaning-list ' + (result.meanings.length === 1 ? 'single' : '')}>
            {result.meanings.map((meaning, meaningIndex: number) => (
              <li key={meaningIndex}>
                <div className="meaning">{
                  meaning.text ? meaning.text : <span className="empty-meaning">{t('(empty)')}</span>
                }</div>
                <WriteOutLink source={result.text} target={meaning.text} />
                <div className="vocabularies">
                  {meaning.vocabularies.map((vocab, vocabIndex: number) => (
                    // <div key={vocabIndex} className="vocabulary-badge">
                    //   <UserIcon userId={vocab.owner_id} userName={vocab.owner_username} />
                    //   {vocab.title}
                    // </div>
                    <Chip
                      key={vocabIndex}
                      size="small"
                      icon={<UserIcon userId={vocab.owner_id} userName={vocab.owner_username} size={20} />}
                      label={vocab.title}
                      color="primary"
                      variant="outlined"
                      onClick={onClickVocabulary(vocab.id, result.text)}
                    />
                  ))}
                </div>
              </li>
            ))}
          </ol>
        </li>
      ))}
    </ul>
  )
}

export default SearchResultsSelf